import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface GradesConsensusData {
  symbol: string;
  strongBuy: number;
  buy: number;
  hold: number;
  sell: number;
  strongSell: number;
  consensus: string;
}

export function useGradesConsensus(symbol: string | undefined) {
  return useQuery<GradesConsensusData, Error>({
    queryKey: ["gradesConsensus", symbol],
    queryFn: async () => {
      if (!symbol) throw new Error("Symbol is required");

      const { data } = await api.get<GradesConsensusData>("/grades-consensus", {
        params: { symbol },
      });
      return data;
    },
    enabled: !!symbol,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    retry: (failureCount, error) => {
      // Don't retry on 404s - no grades data exists for this stock
      if ((error as any)?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
}
